<template>
<div id="updateEmployee">
  <b-tabs content-class="">
                <b-tab title="Fotografía de empleados" class="col-12 mt-5 mx-auto" active @click="photoModule()">
                    <h4>Selecciona un responsable</h4>
                    <p>Recuerda que la persona seleccionada, tendrá habilitado en el sistema la funcionalidad para poder cargar las fotografías de todas las personas asociadas a tu filial.</p>
                    <div class="alert alert-primary d-flex align-items-center">
                        <span class="icon icon-info text-primary mr-4"></span>
                        <p class="p-0 m-0">El sistema solo recibe archivos de imagen en formato <b>JPG</b>  ó <b>JPEG</b>, con un peso máximo de <b>1Mb</b> por cada uno.
                        Para poder relacionar la fotografía a una persona, cada archivo requiere estar nombrado con el <b>número de identificación del empleado.</b></p>
                    </div>

                    <div v-if="search" class="p-2 mt-5">
                        <p class="mt-4 choose">Busca algun trabajador por su nombre, cedula o Sharp ID</p>
                        <v-select class="mt-3 col-6 p-0 " label="name_cc_sharp_id" :options="employeesBySearch" v-model="employee" @search="filterEmployees" @input="searchNewResponsible()">
                            <template slot="no-options">
                            No se encontro ningun trabajador
                            </template>
                        </v-select>
                    </div>
                     <div class="mt-5" v-if="loading2" id="loader"></div>
                     <div v-else>
                         <div v-if="responsible">
                            <h4 class="mt-5">Responsable asignado</h4>
                            <div class="mt-3 table-responsive tableAbs  shadow">
                                <div class="d-flex responsible align-items-center p-4 rounded">
                                    <div class="col-2">
                                        <div class="d-flex flex-column"> 
                                            <img class="centerImg1 mx-auto"  :src="serverPath+'/'+ imageResponsable" width="70%">
                                        </div>
                                    </div>
                                    <div class="col-10">
                                        <datatable
                                        :columns="dataTableResponsible.columns"
                                        :data="dataTableResponsible.rows"
                                        class="col-12 mt-2"
                                        >
                                        </datatable>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button class="regular mt-4" v-if="!search" @click="search = true">Reasignar</button>
                        <button class="btn-create new-responsive mt-4" v-if="search" @click="$bvModal.show('modal-confirm')">Delegar responsabilidad</button>

                        <TablePhoto ref="table"/>

                    </div>
                </b-tab>

                <!-------------------------------- SEGUNDO TAB -------------------------------------------->

                <b-tab title="Teléfonos de contacto" class="col-12 mt-5 mx-auto" @click="phoneModule()">
                    <h4>Selecciona un responsable</h4>
                    <p>Recuerda que la persona seleccionada, tendrá habilitado en el sistema la funcionalidad para poder cargar los números de contacto de todas las personas asociadas a tu filial.</p>
                    <div class="alert alert-primary d-flex align-items-center">
                        <span class="icon icon-info text-primary mr-4"></span>
                        <p class="p-0 m-0">El sistema permite ingresar la información de manera manual o por medio de la carga de un <b>archivo Excel.</b>
Recuerda que si decides hacer la carga del archivo Excel, este debe contener tan solo dos columnas,<b> el numero de identificación del empleado y su numero de contacto.</b></p>
                    </div>

                    <div v-if="searchPhone" class="p-2 mt-5">
                        <p class="mt-4 choose">Busca algun trabajador por su nombre, cedula o Sharp ID</p>
                        <v-select class="mt-3 col-6 p-0 " label="name_cc_sharp_id" :options="employeesBySearch" v-model="employee" @search="filterEmployees" @input="searchNewResponsiblePhone()">
                            <template slot="no-options">
                            No se encontro ningun trabajador
                            </template>
                        </v-select>
                    </div>
                     <div class="mt-5" v-if="loading2" id="loader"></div>
                     <div v-else>
                         <div v-if="responsiblePhoneCheck">
                            <h4 class="mt-5">Responsable asignado</h4>
                            <div class="mt-3 table-responsive tableAbs  shadow">
                                <div class="d-flex responsible align-items-center p-4 rounded">
                                    <div class="col-2">
                                        <div class="d-flex flex-column"> 
                                            <img class="centerImg1 mx-auto"  :src="serverPath+'/'+ imageResponsablePhone" width="70%">
                                        </div>
                                    </div>
                                    <div class="col-10">
                                        <datatable
                                        :columns="dataTableResponsiblePhone.columns"
                                        :data="dataTableResponsiblePhone.rows"
                                        class="col-12 mt-2"
                                        >
                                        </datatable>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button class="regular mt-4" v-if="!searchPhone" @click="searchPhone = true">Reasignar</button>
                        <button class="btn-create new-responsive mt-4" v-if="searchPhone" @click="$bvModal.show('modal-confirm')">Delegar responsabilidad</button>

                        <TablePhone/>
                    </div>
                </b-tab>
  </b-tabs>
            <!-- 3 MODAL CONFIRMAR  -->

           <b-modal v-if="employeeInfo.data" id="modal-confirm" hide-footer centered>
                <div class="col-12 d-flex flex-column align-items-center">
                    <img class="centerImg1" src="@/assets/images/icons/warning.svg" width="20%">
                    <h3 class="pt-5 font-weight-bold">¿Estás seguro de asignarle esta responsabilidad a {{employeeInfo.data.employee.employee}}? </h3>
                    <button class="regular mt-3" @click="$bvModal.hide('modal-confirm')">Cancelar</button>
                    <button class="mt-2 mb-5 col-6 btn btn-success" @click="saveResponsible()">Guardar Cambios</button>
                </div>
            </b-modal>

            <!-- 3 MODAL PROCESO EXITOSO  -->

            <b-modal id="modal-success" hide-footer centered>
                <div class="col-12 d-flex flex-column align-items-center">
                    <img class="centerImg1" src="@/assets/images/icons/check_circle_green.svg" width="20%">
                    <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
                    <p class="pt-5">{{message.message}}</p>
                    <button class="mt-5 mb-5 col-6 btn btn-success" @click="$bvModal.hide('modal-success')">Entendido</button>
                </div>
            </b-modal>

            <!-- 4 MODAL PROCESO FALLIDO -->

            <b-modal v-if="error.message" id="modal-fail" hide-footer centered>
                <div class="col-12 d-flex flex-column align-items-center">
                    <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%">
                    <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
                    <p class="pt-5">{{error.message}}</p>
                    <button class="mt-5 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail')">Entendido</button>
                </div>
            </b-modal>
</div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import TablePhoto from "../delegateUploadHT/tables/tablePhoto.vue"
import TablePhone from "../delegateUploadHT/tables/tablePhone.vue"
import serverConfig from "./../../services/config";
export default {
    components: {
        TablePhoto,
        TablePhone
     },
    data() {
        return {
            photo:false,
            serverPath: serverConfig.permisosURL,
            search:false,
            searchPhone:false,
            responsiblePhoneCheck:false,
            responsible:false,
            imageResponsablePhone:'',
            imageResponsable:'',
            employee:{},
            dataTableResponsible:{
                columns: [],
                rows: [],
            },
            dataTableResponsiblePhone:{
                columns: [],
                rows: [],
            },
        }
    },
    computed: {
        ...mapState("modOhAnalyst", [
        "loading",
        "loading2",
        "error",
        "message",
        "responsiblePhoto",
        "responsiblePhone",
        "employeeInfo",
        "employeesBySearch"
      ]),
     },
    beforeMount(){    
        this.loadResponsablePhoto()
        let data = {
                macro:true
            }
        this.actGetEmployeesBySearch(data)
    },
    methods: {
        ...mapActions("modOhAnalyst", [
        'actResponsiblePhotos',
        'actGetEmployeesBySearch',
        'actGetEmployeeInfoResponsible',
        'actAssignResponsiblePhotos',
        'actResponsiblePhones',
        'actAssignResponsiblePhone'
        ]),
        filterEmployees(search,loading){
            loading(true)
            let data = {
                search: search,
                macro:true
            }
            this.actGetEmployeesBySearch(data).then(() => loading(false))
        },
        loadResponsablePhoto(){
            this.search = (this.search? this.search = false: this.search)
            this.actResponsiblePhotos().then(() => {
                if(this.responsiblePhoto){
                    this.responsible = true
                    this.search = false
                    this.dataTableResponsible.columns = [
                                {
                                    label: "Nombre",
                                    field: "name",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Cargo",
                                    field: "charge",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Area",
                                    field: "area",
                                    align: "left",
                                    headerClass: "theading",
                                }
                                
                    ]
                    this.dataTableResponsible.rows = []

                    this.imageResponsable = this.responsiblePhoto.image
                    
                    this.dataTableResponsible.rows.push({
                            name:this.responsiblePhoto.name,
                            charge:this.responsiblePhoto.charge,
                            area:this.responsiblePhoto.area
                    })
                }else{
                    this.responsible = false
                    this.search = true
                }
            })
        },
        
        searchNewResponsible(){
            this.actGetEmployeeInfoResponsible(this.employee.id).then(()=> {
                this.responsible = true
                this.dataTableResponsible.columns = [
                                {
                                    label: "Nombre",
                                    field: "name",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Cargo",
                                    field: "charge",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Area",
                                    field: "area",
                                    align: "left",
                                    headerClass: "theading",
                                }
                                
                    ]
                this.dataTableResponsible.rows = []

                this.imageResponsable = this.employeeInfo.data.employee.image
                    
                    this.dataTableResponsible.rows.push({
                            name:this.employeeInfo.data.employee.employee,
                            charge:this.employeeInfo.data.employee.charge,
                            area:this.employeeInfo.data.employee.area
                    })
            })
        },
        saveResponsible(){
            if(this.photo){
                this.actAssignResponsiblePhotos(this.employeeInfo.data.employee.id).then(() => {
                    if(this.error.message){
                        this.$root.$emit('bv::hide::modal','modal-confirm')
                        this.$root.$emit('bv::show::modal','modal-fail')
                        this.loadResponsablePhoto()

                    }else{
                        this.$root.$emit('bv::hide::modal','modal-confirm')
                        this.$root.$emit('bv::show::modal','modal-success')
                        this.loadResponsablePhoto()
                    }
                })
            }else if(!this.photo){
                this.actAssignResponsiblePhone(this.employeeInfo.data.employee.id).then(() => {
                    if(this.error.message){
                        this.$root.$emit('bv::hide::modal','modal-confirm')
                        this.$root.$emit('bv::show::modal','modal-fail')
                        this.loadResponsablePhone()

                    }else{
                        this.$root.$emit('bv::hide::modal','modal-confirm')
                        this.$root.$emit('bv::show::modal','modal-success')
                        this.loadResponsablePhone()
                    }
                })
            }
        },

        photoModule(){
            this.photo = true
            this.loadResponsablePhoto()
        },

        ///////////////////////////// funciones responsable Telefono

        phoneModule(){
            this.photo = false
            this.loadResponsablePhone()
        },

        loadResponsablePhone(){
            this.search = (this.search? this.search = false: this.search)
            this.actResponsiblePhones().then(() => {
                if(this.responsiblePhone){
                    this.responsiblePhoneCheck = true
                    this.searchPhone = false
                    this.dataTableResponsiblePhone.columns = [
                                {
                                    label: "Nombre",
                                    field: "name",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Cargo",
                                    field: "charge",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Area",
                                    field: "area",
                                    align: "left",
                                    headerClass: "theading",
                                }
                                
                    ]
                    this.dataTableResponsiblePhone.rows = []
                    
                    this.dataTableResponsiblePhone.rows.push({
                            name:this.responsiblePhone.name,
                            charge:this.responsiblePhone.charge,
                            area:this.responsiblePhone.area
                    })

                    this.imageResponsablePhone = this.responsiblePhone.image
                }else{
                    this.responsiblePhoneCheck = false
                    this.searchPhone = true
                }
            })
        },
            searchNewResponsiblePhone(){
            this.responsiblePhoneCheck = true
            this.actGetEmployeeInfoResponsible(this.employee.id).then(()=> {
                this.dataTableResponsiblePhone.columns = [
                                {
                                    label: "Nombre",
                                    field: "name",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Cargo",
                                    field: "charge",
                                    align: "left",
                                    headerClass: "theading",
                                },
                                {
                                    label: "Area",
                                    field: "area",
                                    align: "left",
                                    headerClass: "theading",
                                }
                                
                 ]

                this.dataTableResponsiblePhone.rows = []
                    
                    this.dataTableResponsiblePhone.rows.push({
                            name:this.employeeInfo.data.employee.employee,
                            charge:this.employeeInfo.data.employee.charge,
                            area:this.employeeInfo.data.employee.area
                    })
                    this.imageResponsablePhone = this.employeeInfo.data.employee.image
            })
        },
    },
}
</script>

<style lang="scss">
#updateEmployee{
    font-family: Open Sans;
    .responsible{
        background-color: #EEF2FA;
    }
    h4{
        font-weight: 600;
        font-size: 16px;
    }
    .alert{
        color:black;
    }
    .icon{
        font-size: 20px;
    }
    .regular{
        padding: 5px 15px;
        font-size: 16px;
        border-radius: 100px;
        background-color: white;
        border: 2px solid #269887;
        color: #269887;
    }
    .btn-create{
        padding: 12px;
        border-radius: 20px;
        background-color: #269887;
        border: none;
        color: white;
        display: flex;
        align-items: center;
        transition: 0.5s;

        span {
            font-size: 30px;
            line-height: 0;
            margin: 0 5px;
            font-weight: 500;
        }
    }
    .btn-create:hover{
        background-color: #27a391;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    }
    .check-status{
        .status{
        padding: 5px 10px;
        border-radius: 20px;
        font-size: 14px;
        }
    }
    .progress{
        height: 20px;
        border-radius: 10px;
        .progress-bar{
        background: linear-gradient(270deg, #0C9E42 -0.16%, #00E455 100%);
        }
    }
}
</style>